import React from "react";
import { Template } from "../../model/accounting/template/Template.js";
import { ListItem } from "../../../packages/ui/list/ListItem.js";
import { Link } from "../../../packages/router/Link.js";

type Props = {
  template: Template;
};

/**
 * Renders one item in the template selector list.
 */
export const TemplateItem = ({ template }: Props) => {
  return (
    <ListItem>
      <Link to={`/template/${template.id}`}>{template.name}</Link>
    </ListItem>
  );
};
